import { AbstractAuditDto, AuditViewDto, DocumentDto, MinorDataDto, MsisdnDto, ResultListDto, RolePermissionEnum, SearchResultDocumentDto, SubscriberFullDto, GovernmentRecordDto } from './../../service/dto';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize, map, Observable, Subscription } from 'rxjs';
import { AbstractDto } from '../../service/dto';
import { HttpSubscriberService } from '../../service/http-subscriber.service';
import { AuthService } from '../../service/auth.service';
import { HttpAuditService } from '../../service/http-audit.service';
import { faCheck, faExpand, faHourglass, faNotdef, faXmark } from '@fortawesome/free-solid-svg-icons';
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { HttpEventType } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

class DocumentWithVerificationWrapper {
	document!: DocumentDto;
	governmentRecord?: GovernmentRecordDto;
	isVerifying!: boolean;
}
@Component({
	selector: 'app-subscriber-view',
	templateUrl: './subscriber-view.component.html',
	styleUrl: './subscriber-view.component.scss',
	standalone: false
})
export class SubscriberViewComponent implements OnInit, OnDestroy {
	@ViewChild('contentToPrint', { static: false }) contentToPrintElement!: ElementRef;
	private subscription = new Subscription();
	data?: SubscriberFullDto;
	documentWithVerificationList: DocumentWithVerificationWrapper[] = [];
	searchType?: 'sim' | 'document';
	searchRef?: number;
	selectedTabIndex = 0;
	views!: Observable<AbstractAuditDto[]>;

	faExpand = faExpand;
	faCheck = faCheck;
	faXmark = faXmark;
	faNotdef = faNotdef;
	faHourglass = faHourglass;

	uploadProgressCdr?: number;
	uploadProgressDocumentFront?: number;
	uploadProgressDocumentBack?: number;
	uploadProgressPortrait?: number;
	uploadProgressProofOfAddress?: number;

	imagePreviewDocumentBack?: string | ArrayBuffer | SafeUrl | null = null;
	imagePreviewDocumentFront?: string | ArrayBuffer | SafeUrl | null = null;
	imagePreviewPortrait?: string | ArrayBuffer | SafeUrl | null = null;
	imagePreviewProofOfAddress?: string | ArrayBuffer | SafeUrl | null = null;

	constructor(private sanitizer: DomSanitizer, private service: HttpSubscriberService, private auditService: HttpAuditService, private activatedRoute: ActivatedRoute, private authService: AuthService, private message: NzMessageService) {

	}

	ngOnInit(): void {
		this.subscription = this.activatedRoute.params.subscribe(params => {
			this.searchType = undefined;
			this.searchRef = undefined;
			const personId = +params['personId'];
			this.service.getFullSubscriber(personId).subscribe({
				next: data => {
					this.searchType = params['searchType'] as 'sim' | 'document';
					this.searchRef = +params['searchRef'];
					this.setData(data);
				},
				error: err => console.error('Failed to load subscriber', err)
			});
		});
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	private setData(input: SubscriberFullDto) {
		this.data = input;
		this.documentWithVerificationList = this.data.documents.map(document => {
			const governmentRecord = this.data?.governmentRecords.filter(i => i.id === document.governmentRecordId)[0];
			return { document: document, governmentRecord: governmentRecord, isVerifying: false };
		});

		this.imagePreviewDocumentBack = this.data.person.imageBack ? this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.data.person.imageBack!.imageData) : '';
		this.imagePreviewDocumentFront = this.data.person.imageFront ? this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.data.person.imageFront!.imageData) : '';
		this.imagePreviewPortrait = this.data.person.imagePortrait ? this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.data.person.imagePortrait!.imageData) : '';
		this.imagePreviewProofOfAddress = this.data.person.imageProofOfAddress ? this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.data.person.imageProofOfAddress!.imageData) : '';
	}

	getDocumentGivenNames(document: DocumentDto): string {
		let out = '';
		let seperator = '';
		if (document.firstName) {
			out += seperator + document.firstName;
			seperator = ' ';
		}
		if (document.secondName) {
			out += seperator + document.secondName;
			seperator = ' ';
		}
		if (document.otherNames) {
			out += seperator + document.otherNames;
			seperator = ' ';
		}
		return out;
	}
	getMinorGivenNames(minor: MinorDataDto): string | undefined {
		if (!minor) {
			return undefined;
		}
		let out = '';
		let seperator = '';
		if (minor.firstName) {
			out += seperator + minor.firstName;
			seperator = ' ';
		}
		if (minor.secondName) {
			out += seperator + minor.secondName;
			seperator = ' ';
		}
		if (minor.otherNames) {
			out += seperator + minor.otherNames;
			seperator = ' ';
		}
		return out;
	}
	findMinorIndexPlus1(msisdn: MsisdnDto): number | undefined {
		if (!msisdn.minorDataId) {
			return undefined;
		}
		for (let i = 0; i < this.data!.minors.length; i++) {
			if (this.data?.minors[i].id == msisdn.minorDataId) {
				return i + 1;
			}
		}
		return undefined;
	}

	findMinor(msisdn: MsisdnDto): MinorDataDto | undefined {
		if (!msisdn.minorDataId) {
			return undefined;
		}
		for (let i = 0; i < this.data!.minors.length; i++) {
			if (this.data?.minors[i].id == msisdn.minorDataId) {
				return this.data?.minors[i];
			}
		}
		return undefined;
	}



	trackByHashCode(index: number, item: AbstractDto): any {
		return item.hashCode;
	}
	fetchAudits = (page: number, pageSize: number): Observable<ResultListDto<AuditViewDto>> => {
		return this.auditService.getViewHistoryOfSubscriber(this.data!.person.id, page, pageSize);
	}
	doVerify(input: DocumentWithVerificationWrapper) {
		input.isVerifying = true;
		this.service.doVerifyDocument(this.data!.person.id, input.document)
			.pipe(finalize(() => input.isVerifying = false))
			.subscribe(result => this.setData(result));
	}





	beforeUploadCdr = (file: NzUploadFile, fileList: NzUploadFile[]): boolean => {
		if (file.type === 'text/csv') {
			return true;
		}
		this.message.warning('Invalid file format. Please upload a CSV.');
		return false;
	}
	customUploadCdr = (item: NzUploadXHRArgs): any => {
		this.uploadProgressCdr = 0;
		const subscription = this.service.uploadCdrCsvFile(this.data!.person.id, item.file as any)
			.pipe(finalize(() => this.uploadProgressCdr = undefined))
			.subscribe({
				next: (event) => {
					if (event.type === HttpEventType.Response) {
						const body = event.body as SubscriberFullDto;
						this.uploadProgressCdr = 100;
						this.message.info("Upload Done");
						this.setData(body);
					}
					if (event.type === HttpEventType.UploadProgress) {
						console.log(`Event Total: [${event.total} - Event Loaded [${event.loaded}]]`);
						const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
						this.uploadProgressCdr = percentage == 100 ? 99 : percentage;
					}
				},
				error: (err) => item.onError!(err, item.file!)
			});
		return { abort() { subscription.unsubscribe(); } };
	}


	beforeUploadDocumentBack = (file: NzUploadFile, fileList: NzUploadFile[]): boolean => {
		if (file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png') {
			const reader = new FileReader();
			reader.onload = () => {
				this.imagePreviewDocumentBack = reader.result;
			};
			reader.readAsDataURL(file as any as File);
			return true;
		}
		this.message.warning('Invalid file format. Please upload a JPG or PNG.');
		return false;
	}
	customUploadDocumentBack = (item: NzUploadXHRArgs): any => {
		this.uploadProgressDocumentBack = 0;
		const subscription = this.service.doUploadImageBack(this.data!.person.id, item.file as any)
			.pipe(finalize(() => this.uploadProgressDocumentBack = undefined))
			.subscribe({
				next: (event) => {
					if (event.type === HttpEventType.Response) {
						const body = event.body as SubscriberFullDto;
						this.uploadProgressDocumentBack = 100;
						this.message.info("Upload Done");
						this.setData(body);
					}
					if (event.type === HttpEventType.UploadProgress) {
						console.log(`Event Total: [${event.total} - Event Loaded [${event.loaded}]]`);
						const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
						this.uploadProgressDocumentBack = percentage == 100 ? 99 : percentage;
					}
				},
				error: (err) => item.onError!(err, item.file!)
			});
		return { abort() { subscription.unsubscribe(); } };
	}
	handleChangeDocumentBack(info: { file: NzUploadFile }): void {
		switch (info.file.status) {
			case 'uploading':
				break;
			case 'done':
				// Get this url from response in real world.
				this.getBase64(info.file!.originFileObj!, (img: string) => {
					this.imagePreviewDocumentBack = img;
				});
				break;
			case 'error':
				break;
		}
	}


	beforeUploadDocumentFront = (file: NzUploadFile, fileList: NzUploadFile[]): boolean => {
		if (file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png') {
			const reader = new FileReader();
			reader.onload = () => {
				this.imagePreviewDocumentFront = reader.result;
			};
			reader.readAsDataURL(file as any as File);
			return true;
		}
		this.message.warning('Invalid file format. Please upload a JPG or PNG.');
		return false;
	}
	customUploadDocumentFront = (item: NzUploadXHRArgs): any => {
		this.uploadProgressDocumentFront = 0;
		const subscription = this.service.doUploadImageFront(this.data!.person.id, item.file as any)
			.pipe(finalize(() => this.uploadProgressDocumentFront = undefined))
			.subscribe({
				next: (event) => {
					if (event.type === HttpEventType.Response) {
						const body = event.body as SubscriberFullDto;
						this.uploadProgressDocumentFront = 100;
						this.message.info("Upload Done");
						this.setData(body);
					}
					if (event.type === HttpEventType.UploadProgress) {
						console.log(`Event Total: [${event.total} - Event Loaded [${event.loaded}]]`);
						const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
						this.uploadProgressDocumentFront = percentage == 100 ? 99 : percentage;
					}
				},
				error: (err) => item.onError!(err, item.file!)
			});
		return { abort() { subscription.unsubscribe(); } };
	}
	handleChangeDocumentFront(info: { file: NzUploadFile }): void {
		switch (info.file.status) {
			case 'uploading':
				break;
			case 'done':
				// Get this url from response in real world.
				this.getBase64(info.file!.originFileObj!, (img: string) => {
					this.imagePreviewDocumentFront = img;
				});
				break;
			case 'error':
				break;
		}
	}



	beforeUploadPortrait = (file: NzUploadFile, fileList: NzUploadFile[]): boolean => {
		if (file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png') {
			const reader = new FileReader();
			reader.onload = () => {
				this.imagePreviewPortrait = reader.result;
			};
			reader.readAsDataURL(file as any as File);
			return true;
		}
		this.message.warning('Invalid file format. Please upload a JPG or PNG.');
		return false;
	}
	customUploadPortrait = (item: NzUploadXHRArgs): any => {
		this.uploadProgressPortrait = 0;
		const subscription = this.service.doUploadImagePortrait(this.data!.person.id, item.file as any)
			.pipe(finalize(() => this.uploadProgressPortrait = undefined))
			.subscribe({
				next: (event) => {
					if (event.type === HttpEventType.Response) {
						const body = event.body as SubscriberFullDto;
						this.uploadProgressPortrait = 100;
						this.message.info("Upload Done");
						this.setData(body);
					}
					if (event.type === HttpEventType.UploadProgress) {
						console.log(`Event Total: [${event.total} - Event Loaded [${event.loaded}]]`);
						const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
						this.uploadProgressPortrait = percentage == 100 ? 99 : percentage;
					}
				},
				error: (err) => item.onError!(err, item.file!)
			});
		return { abort() { subscription.unsubscribe(); } };
	}
	handleChangePortrait(info: { file: NzUploadFile }): void {
		switch (info.file.status) {
			case 'uploading':
				break;
			case 'done':
				// Get this url from response in real world.
				this.getBase64(info.file!.originFileObj!, (img: string) => {
					this.imagePreviewPortrait = img;
				});
				break;
			case 'error':
				break;
		}
	}


	beforeUploadProofOfAddress = (file: NzUploadFile, fileList: NzUploadFile[]): boolean => {
		if (file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png') {
			const reader = new FileReader();
			reader.onload = () => {
				this.imagePreviewProofOfAddress = reader.result;
			};
			reader.readAsDataURL(file as any as File);
			return true;
		}
		this.message.warning('Invalid file format. Please upload a JPG or PNG.');
		return false;
	}
	customUploadProofOfAddress = (item: NzUploadXHRArgs): any => {
		this.uploadProgressProofOfAddress = 0;
		const subscription = this.service.doUploadImageProofOfAddress(this.data!.person.id, item.file as any)
			.pipe(finalize(() => this.uploadProgressProofOfAddress = undefined))
			.subscribe({
				next: (event) => {
					if (event.type === HttpEventType.Response) {
						const body = event.body as SubscriberFullDto;
						this.uploadProgressProofOfAddress = 100;
						this.message.info("Upload Done");
						this.setData(body);
					}
					if (event.type === HttpEventType.UploadProgress) {
						console.log(`Event Total: [${event.total} - Event Loaded [${event.loaded}]]`);
						const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
						this.uploadProgressProofOfAddress = percentage == 100 ? 99 : percentage;
					}
				},
				error: (err) => item.onError!(err, item.file!)
			});
		return { abort() { subscription.unsubscribe(); } };
	}
	handleChangeProofOfAddress(info: { file: NzUploadFile }): void {
		switch (info.file.status) {
			case 'uploading':
				break;
			case 'done':
				// Get this url from response in real world.
				this.getBase64(info.file!.originFileObj!, (img: string) => {
					this.imagePreviewProofOfAddress = img;
				});
				break;
			case 'error':
				break;
		}
	}



	private getBase64(img: File, callback: (img: string) => void): void {
		const reader = new FileReader();
		reader.addEventListener('load', () => callback(reader.result!.toString()));
		reader.readAsDataURL(img);
	}
}
